<template>
  <div>
    <div class="detail-table">

      <div v-if="caseInfo">
        <InfoView ref="v1" refName="v1" title="设备池名称" msg="" :list="nameList" :info="caseInfo" :save="saveCaseInfoNew" editBtnName="修改备注"></InfoView>
        <InfoView ref="v2" refName="v2" title="网络设置" msg="设备池的网络，NTP服务器地址等相关内容" :list="netList" :info="caseInfo" :save="saveCaseInfoNew" editBtnName="设置"></InfoView>
        <InfoView  v-if="$store.state.needLayer" ref="v3" refName="v3" title="分层设置" msg="设备池的分层处理器IP，用于管理应用分发等" :list="cenList" :info="caseInfo" :save="saveCaseInfoNew" editBtnName="设置"></InfoView>
        <InfoView ref="v4" refName="v4" title="IP设置" msg="设备池内设备的起始IP，设置后设备池内的设备IP会根据起始IP自动递增" :list="ipList" :info="ipSetInfo" :save="ipSet" editBtnName="设置"></InfoView>
      </div>
      <el-dialog title="IP批量修改成功" :append-to-body="true" :visible.sync="ipSuccessPopShow" width="500px" top="15vh">
        <div>
          <el-table :data="ipSuccessList">
            <el-table-column type="index" label="ID"></el-table-column>
            <el-table-column property="deviceIpBefore" label="修改前IP"></el-table-column>
            <el-table-column label="修改后IP">
              <template slot-scope="scope">
                <div v-if="scope.row.isSuccess">{{scope.row.deviceIpAfter}}</div>
                <div v-else style="color: red">失败</div>
              </template>
            </el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="ipSuccessPopShow = false">确 定</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 备注设置 -->
      <el-dialog title="修改备注" :append-to-body="true" :visible.sync="remarkPopShow" width="500px" top="15vh">
        <div>
          <el-form ref="form" :model="caseInfo" label-width="130px" label-position="left">
            <el-form-item size="mini" label="备注">
              <el-input v-model="caseInfo.remark"></el-input>
            </el-form-item>
            <el-form-item size="mini">
              <el-button type="primary" @click="remarkChange">确定</el-button>
              <el-button @click="remarkPopShow = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import DetailTableItem from "@/components/DetailTableItem"
  import InfoView from "@/components/InfoView"

  export default {
  name: "DetailTable",
  components: {
    DetailTableItem,
    InfoView
  },
  data () {
    return {
      enginePopShow: false,
      networkPopShow: false,
      nodePopShow: false,
      ipPopShow: false,
      ipSuccessPopShow: false,
      remarkPopShow: false,
      caseInfo: null,
      ipSuccessList: [
        {
          deviceIpBefore: '1.1.1.1',
          deviceIpAfter: '1.1.2.4',
          isSuccess: true
        },
        {
          deviceIpBefore: '1.1.1.2',
          deviceIpAfter: '1.1.2.5',
          isSuccess: false
        },
        {
          deviceIpBefore: '1.1.1.3',
          deviceIpAfter: '1.1.2.6',
          isSuccess: true
        },
        {
          deviceIpBefore: '1.1.1.4',
          deviceIpAfter: '1.1.2.7',
          isSuccess: true
        }
      ],
      ipChangeInfo: {
        caseId: "",
        initialIp: "",
        route: "",
        netmask: "255.255.0.0",
        webIp: "",
        webPort: ""
      },
      list: [],
      nameList: [
        {
          name: 'ID',
          key: 'caseNo',
          edit: false,
        },{
          name: '备注',
          key: 'remark',
          edit: true,
          notNull: false,
          value: ''
        }
      ],
      netList: [
        {
          name: '网关',
          key: 'route',
          edit: true,
          notNull: true,
          value: '',
          valid: false,
          regex: /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/,
          errorMsg: '填写正确的网关ip'
        },{
          name: '子网掩码',
          key: 'netmask',
          edit: true,
          notNull: true,
          value: '',
          valid: false,
          regex: /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/,
          errorMsg: '填写正确的子网掩码'
        },{
          name: 'DNS',
          key: 'dns',
          edit: true,
          notNull: true,
          value: '',
          valid: false,
          regex: /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/,
          errorMsg: '填写正确的dns'
        },{
          name: 'NTP地址',
          key: 'ntpAddress',
          edit: true,
          // notNull: true,
          value: '',
          valid: false,
          regex: null
        },{
          name: '初始端口',
          key: 'initialPort',
          edit: true,
          // notNull: true,
          value: '',
          valid: false,
          regex: null
        },{
          name: 'ADB端口',
          key: 'adbPort',
          edit: true,
          // notNull: true,
          value: '',
          valid: false,
          regex: null
        },{
          name: '是否有状态',
          key: 'isStatus',
          edit: true,
          notNull: true,
          value: '',
          type: 'switch',
          active: '1',
          inactive: '0',
          show: (status) => {
            return status == 1 ? '是' : '否'
          },
          valid: false,
          regex: null
        },{
          name: '是否锁定',
          key: 'isLock',
          edit: true,
          notNull: true,
          value: '',
          type: 'switch',
          active: '2',
          inactive: '1',
          show: (status) => {
            return status == 2 ? '是' : '否'
          },
          valid: false,
          regex: null
        }
      ],
      cenList: [
        {
          name: '分层处理器IP',
          key: 'nodeIp',
          edit: true,
          notNull: true,
          value: ''
        },{
          name: '备用分层处理器IP',
          key: 'nodeIpBak',
          edit: true,
          notNull: true,
          value: ''
        }
      ],
      ipList: [
        {
          name: '设备池起始IP',
          key: 'initialIp',
          edit: true,
          notNull: true,
          value: ''
        },{
          name: '网关',
          key: 'route',
          edit: true,
          notNull: true,
          value: ''
        },{
          name: '子网掩码',
          key: 'netmask',
          edit: true,
          notNull: true,
          value: ''
        },{
          name: '网管IP',
          key: 'webIp',
          edit: true,
          notNull: true,
          value: ''
        }
      ]
    }
  },
  computed: {
    canSave() {
      for (let item of this.netList) {
        if (item.notNull && !item.value) {
          return false
        }
      }
      return true
    },
    ipSetInfo() {
      return {
        caseId: this.caseInfo.id,
        initialIp: this.caseInfo.nodeIp,
        route: this.caseInfo.route,
        netmask: "255.255.0.0",
        webIp: "",
        webPort: ""
      }
    }

  },
  methods: {
      checkLicenseService(index) {
          let found = -1
          if (this.$store.state.licenseInfo && this.$store.state.licenseInfo) {
              let serviceItems = this.$store.state.licenseInfo.service.toString().split(",")
              serviceItems.forEach(item => {
                  // console.log("item is " + item + ", index is " + index)
                  if (item == index) {
                      found = 1
                      return
                  }
              })
          }
          return found
      },
    /* 修改设备池信息 */
    saveCaseInfo () {
      this.$post(this.$uri.device.caseInfoSave, this.caseInfo).then(res => {
          this.networkPopShow = false
          this.nodePopShow = false
          this.remarkPopShow = false
          this.$message.success("修改成功")
        // 把修改保存到store
          this.$store.commit(this.$mutation.CASE_DETAIL, this.caseInfo)
        // 刷新数据
        this.list = this.$store.getters.detailTableList
      })
    },
    /* 修改设备池信息 */
    saveCaseInfoNew (info, refName) {
      // console.log('saveCaseInfoNew')
      //   console.log("refName is " + refName)
      // console.log(info)

        if (refName == 'v1') {
            this.caseInfo.remark = info.remark;
        }
        else if (refName == 'v2') {
            this.caseInfo.adbPort = info.adbPort;
            this.caseInfo.route = info.route;
            this.caseInfo.netmask = info.netmask;
            this.caseInfo.initialPort = info.initialPort;
            this.caseInfo.dns = info.dns;
            this.caseInfo.isStatus = info.isStatus;
            this.caseInfo.isLock = info.isLock;
            this.caseInfo.ntpAddress = info.ntpAddress;
        } else if (refName == 'v3') {
            this.caseInfo.nodeIp = info.nodeIp;
            this.caseInfo.nodeIpBak = info.nodeIpBak;
        } else if (refName == 'v4') {

        }
        console.log(this.caseInfo)
        this.$post(this.$uri.device.caseInfoSave, this.caseInfo ).then(res => {
            this.networkPopShow = false
            this.nodePopShow = false
            this.remarkPopShow = false
            this.$message.success("修改成功")
            this.$refs[refName].isEdit = false

            this.$store.commit(this.$mutation.CASE_DETAIL, this.caseInfo )
            // this.caseInfo = JSON.parse(JSON.stringify(info))
        // 刷新数据
        this.list = this.$store.getters.detailTableList
      })
    },
    /* 网络设置 */
    networkSet () {
      this.saveCaseInfo()
    },
    /* 网络设置弹窗 */
    networkSetPop () {
      this.networkPopShow = true
    },
    /* 分层设置 */
    nodeSet () {
      this.saveCaseInfo()
    },
    /* ip设置 */
    ipSet (info, refName) {
      let that = this
      if (!/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|20\d|21[0-5])$/.test(info.initialIp)){
        that.$message.error("初始IP末位请务必在1-215之间")
        return
      }
      let reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
      if (!reg.test(info.route) || !reg.test(info.webIp) || !reg.test(info.netmask)){
        that.$message.error("请填写正确的ip")
        return
      }

      this.$confirm('点击确定后将对设备IP进行自动填充修改，修改后设备会重启，如果输入有误，请点击取消返回修改，确定无误后，点击确认则对修改生效。', '提示', {
        confirmButtonText: '确定',
        confirmButtonClass: 'confirm-btn-red',
        iconClass: 'el-icon-c-red',
        cancelButtonText: '取消'
      }).then(() => {
        that.$post(that.$uri.device.updateDeviceIp, info).then(res => {
          if (res.success) {
            that.ipSuccessList = res.list
            that.ipSuccessPopShow = true
          } else {
            that.$message.error(res.message)
          }
        })
      }).catch(() => {});
    },
    /* 分层设置弹窗 */
    nodeSetPop () {
      this.nodePopShow = true
    },
    /* 设备IP设置弹窗 */
    ipSetPop () {
      /*let that = this
      that.$post(that.$uri.device.deviceList, {caseNo: that.caseInfo.caseNo}).then(res => {
        if (res.success) {
          for (let i in res.list) {
            if (res.list[i].cardType === 2) {
              that.ipChangeInfo.webIp = res.list[i].nodeIp
            }
          }
        }
      })*/
      this.ipChangeInfo.route = this.caseInfo.route
      this.ipChangeInfo.initialIp = this.caseInfo.nodeIp
      this.ipPopShow = true
    },
    /* 修改备注 */
    remarkChange () {
      this.saveCaseInfo()
    },
    /* 修改备注弹窗 */
    remarkChangePop () {
      this.remarkPopShow = true
    },
    /* 下拉菜单事件 */
    handleCommand (command) {
      switch (command) {
        case "networkSet": this.networkSetPop(); break;
        case "nodeSet": this.nodeSetPop(); break;
        case "remarkChange": this.remarkChangePop(); break
      }
    },
      getSysIsNode() {
          this.$post(this.$uri.system.paramGet, { paramName:"isNode" }).then(res => {
              if (res.success) {
                  // console.log("getSysIsNode res is " + JSON.stringify(res))
                  if (res.data.paramValue == 1) {
                      // console.log("set NEED_LAYER true")
                      this.$store.commit(this.$mutation.IS_NEED_LAYER, true)
                  } else {
                      // console.log("set NEED_LAYER false")
                      this.$store.commit(this.$mutation.IS_NEED_LAYER, false)
                  }
              }
          })
      },
  },
  created () {
      this.getSysIsNode()
      if(this.$store.state.licenseInfo && this.checkLicenseService(4) === -1) {
          this.netList.splice(5, 1)
      }
    this.caseInfo = this.$store.state.caseInfo
    this.caseInfo.isStatus += ""
    this.caseInfo.isLock += ""
    this.list = this.$store.getters.detailTableList
    // console.log(this.$store.state.caseInfo)
  }
};
</script>

<style lang="less" scoped>
.detail-table {
  padding-bottom: 50px;
  .detail-table-header {
    padding-left: 12px;
    background: #f5f6fa;
    border-bottom: 1px solid #ebeef5;
    border-left: 4px solid #6d7781;
    cursor: pointer;
    height: 38px;
    -webkit-transition: border-bottom-color 0.3s;
    transition: border-bottom-color 0.3s;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .detail-table-header-name {
      line-height: 38px;
      color: #303133;
      font-size: 13px;
      font-weight: 500;
      outline: 0;
      text-align: left;
    }
    .detail-table-setting {
      font-size: 12px;
      color: #606266;
      margin-right: 10px;
    }
  }
  .detail-table-body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .detail-table-body-item {
      flex-grow: 1;
      width: 40%;
    }
  }
}
.detail-setting {
  margin-top: 20px;
  text-align: left;
}
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
.info-view {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 10px;
  border-bottom: 1px solid #E1E6EB;
  .info-view-title {
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    padding: 5px 10px;
  }
  .info-view-main {
    padding: 10px 10px 10px 120px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: flex-start;
    .info-view-item {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 2px 0;
      height: 30px;
    }
    .info-view-item-btn {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 5px 0;
    }
  }
}
</style>